var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#0071B3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1300_20330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.031 24.617L30.314 28.899L28.899 30.314L24.617 26.031C23.0237 27.3082 21.042 28.0029 19 28C14.032 28 10 23.968 10 19C10 14.032 14.032 10 19 10C23.968 10 28 14.032 28 19C28.0029 21.042 27.3082 23.0237 26.031 24.617ZM24.025 23.875C25.2941 22.5699 26.0029 20.8204 26 19C26 15.132 22.867 12 19 12C15.132 12 12 15.132 12 19C12 22.867 15.132 26 19 26C20.8204 26.0029 22.5699 25.2941 23.875 24.025L24.025 23.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1300_20330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.09aba2105bcacbd22b5964cef7a30565.svg";
export { ForwardRef as ReactComponent };